import { useStore } from 'react-redux';
import WebAPIUtils from '../../../WebAPIUtils';
import Field from '../../../model/Field';
import { LayerValuesForFields } from './SeedingJobCommonTypes';
import { Layer } from '../PrescriptionJob';

export const useSoilAnalysisForSeedingCalculations = () => {
  const store = useStore();

  const fetchLayerValuesForFields = async (
    layers: Layer[],
    fieldId: number,
    onlyCurrentField: boolean = false
  ) => {
    let fieldIds: number[] = [];
    if (store.getState().prescription.isBulkPrescription && !onlyCurrentField) {
      fieldIds = store
        .getState()
        .prescription.bulkPrescription.fields.map((field: Field) => field.fieldId);
    } else {
      fieldIds = [fieldId];
    }

    const promises = fieldIds.map(async (fieldId: number) => {
      try {
        const result = await WebAPIUtils.getMultipleSurveyLayerValues(
          store.getState().farm.farm.farmId,
          fieldId,
          store.getState().survey.surveys.filter((survey) => survey.fieldId === fieldId),
          layers
        );

        if (!result[0] || !result[1] || !result[2]) {
          throw Error(`Missing soil analysis data for one or more layers`);
        }

        const resultsWithLayers = {};
        layers.forEach((layer: Layer) => {
          const index: number = layers.findIndex((l) => l === layer);
          resultsWithLayers[layer] = result[index];
        });

        return { [fieldId]: resultsWithLayers };
      } catch (error) {
        console.error(`Error fetching soil analysis for field ${fieldId}:`, error);
        const resultsWithLayers = {};
        layers.forEach((layer: Layer) => {
          resultsWithLayers[layer] = [];
        });
        return { [fieldId]: resultsWithLayers };
      }
    });

    let result: LayerValuesForFields = {};

    const results = await Promise.resolve(Promise.all(promises));
    result = results.reduce(
      (acc: LayerValuesForFields, curr: LayerValuesForFields) => ({ ...acc, ...curr }),
      result
    );
    return result;
  };

  return { fetchLayerValuesForFields };
};
